/**
 * Checks if the device is a tablet based on the user agent string.
 * Detects common tablet patterns including iPad, Android tablets, BlackBerry PlayBook, and Amazon Fire tablets.
 * @returns true if the user agent indicates a tablet device, false otherwise
 */
export const isTabletDevice = (): boolean => {
  const userAgent = window.navigator.userAgent;
  const isTabletViewport = window.matchMedia('only screen and (min-width: 600px) and (max-width: 1024px)').matches;
  return (
    (isTabletViewport && /(tablet|ipad|playbook|silk)/i.test(userAgent) && 'ontouchstart' in window) ||
    navigator.maxTouchPoints > 0
  );
};
